import instance from '@apis/instance';
import { TermRow, TermsResponse } from '@models/term';

class TermApi {
  static getTermsByCategory(termCategoryId: string): Promise<TermsResponse> {
    return instance.get(`/terms-category/${termCategoryId}/terms`);
  }

  static getMainTermByCategory(termCategoryId: string): Promise<TermRow> {
    return instance.get(`/terms-category/${termCategoryId}/main-terms`);
  }
}

export default TermApi;
